export default __webpack_public_path__ + "a2c1f490afa877037b6c62cc0d33f034.png";